const ORGS_WITHOUT_ISSENCE_SITE_PROPERTIES = new Set([
  'b6236b42-6c33-4b12-9626-ace0b682ee13', // Gravus
]);

export function canUseIssenceSiteProperties(organizationId: string | null | undefined): boolean {
  return !organizationId || !ORGS_WITHOUT_ISSENCE_SITE_PROPERTIES.has(organizationId);
}
